import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {RootState} from "../../../redux/store";
import {SaveAltSharp} from "@mui/icons-material";
import Button from "../../../Atoms/Button";
import React, {useEffect} from "react";
import {AdventureOverviewTab} from "./AdventureTabs/AdventureOverviewTab";
import {AdventurePlayerTab} from "./AdventureTabs/AdventurePlayerTab";
import {AdventureCharacterSheetTab} from "./AdventureTabs/AdventureCharacterSheetTab";
import {useMutation, useQuery, useSubscription} from "@apollo/client";
import {GetAdventureById} from "../../../GraphQL/AdventureQueries";
import {setAdventure} from "../../../redux/slices/adventure/adventureSlice";
import {updateAdventure} from "../../../GraphQL/AdventureMutation";
import {toast} from "react-toastify";
import {setIsAppLoading} from "../../../redux/slices/content/contentSlice";
import {createMessage} from "../../../GraphQL/MessageMutation";
import {GetMessages} from "../../../GraphQL/MessageQuery";
import {user_to_adventure} from '../../../redux/slices/adventure/adventureType';
import {AdventureNPC} from './AdventureTabs/AdventureNPC';
import {listenToAdventure} from "../../../GraphQL/Subscription";

export enum Tabs {
    Overview = "Overview",
    Spielerverwaltung = "Spielerverwaltung",
    Spieleroverview = "Spieleroverview",
    NPCTab = "NPCTab"
}

export const AdventureMask = () => {
    const adventure = useAppSelector((state: RootState) => state.adventure);
    const user = useAppSelector((state: RootState) => state.user)
    const dispatch = useAppDispatch();

    const [ selectedTab, setSelectedTab ] = React.useState<Tabs>(Tabs.Overview);
    const [ selectedPlayer, setSelectedPlayer ] = React.useState<user_to_adventure | null>(null);

    const [
        updateAdventureHook, {
            data: updateAdventureData,
            loading: updateAdventureLoading,
            error: updateAdventureError
        } ] = useMutation(updateAdventure)
    const {
        data: adventureQueryData,
        loading: adventureQueryLoading,
        error: adventureQueryError
    } = useQuery(GetAdventureById, {
        variables: {
            adventureId: Number(adventure.adventureId)
        },
        fetchPolicy: 'network-only'
    })
    const [
        createMessageHook, {
            data: createMessageData,
            loading: createMessageLoading,
            error: createMessageError
        } ] = useMutation(createMessage)


    const {data: subData, loading: subLoading, error: subError} = useSubscription(listenToAdventure, {
        variables: {
            adventureId: Number(adventure.adventureId)
        },
        fetchPolicy: 'network-only',
        onData({ data: subData }) {
            console.log('Änderungen')
            dispatch(setAdventure({
                adventureId: subData.data.listenToAdventure.adventureId,
                adventureDesc: subData.data.listenToAdventure.adventureDescription,
                adventureName: subData.data.listenToAdventure.adventureName,
                user_to_adventure: subData.data.listenToAdventure.user_to_adventure
            }))
        }
    })

    useEffect(() => {
        if (adventureQueryData && !adventureQueryLoading) {
            dispatch(setAdventure({
                adventureId: adventureQueryData.getAdventureById.adventureId,
                adventureDesc: adventureQueryData.getAdventureById.adventureDescription,
                adventureName: adventureQueryData.getAdventureById.adventureName,
                user_to_adventure: adventureQueryData.getAdventureById.user_to_adventure
            }))
        }
    }, [ adventureQueryData ])

    useEffect(() => {
        if (updateAdventureLoading) {
            dispatch(setIsAppLoading({loadingText: 'Abenteuer wird gespeichert', isAppLoading: true}))
        } else {
            dispatch(setIsAppLoading({loadingText: '', isAppLoading: false}))
        }
    }, [ updateAdventureLoading ])

    useEffect(() => {
        if (adventureQueryLoading) {
            dispatch(setIsAppLoading({loadingText: 'Abenteuer wird geladen', isAppLoading: true}))
        } else {
            dispatch(setIsAppLoading({loadingText: '', isAppLoading: false}))
        }
    }, [ adventureQueryLoading ])

    useEffect(() => {
        if (adventureQueryError) {
            toast('Fehler beim Laden des Abenteuers')
        }
    }, [ adventureQueryError ])

    const checkForSelectedTab = (tab: string) => {
        if (tab === selectedTab) {
            return 'tab-button-selected'
        } else {
            return 'tab-button'
        }
    }

    const renderContent = () => {
        switch (selectedTab) {
            case Tabs.Overview:
                return <AdventureOverviewTab/>
            case Tabs.Spielerverwaltung:
                return <AdventurePlayerTab changeTab={setSelectedTab} setSelectedPlayer={setSelectedPlayer}/>
            case Tabs.Spieleroverview:
                return <AdventureCharacterSheetTab selectedPlayer={selectedPlayer}
                                                   setSelectedPlayer={setSelectedPlayer}/>
            case Tabs.NPCTab:
                return <AdventureNPC/>
        }
    }

    const handleUpdateAdventure = async () => {
        const userList = [];
        for (const uta of adventure.user_to_adventure) {
            userList.push(Number(uta.User.userId))
            if (uta.userToAdventureId < 0) {
                await createMessageHook({
                    variables: {
                        messageText: `Sie wurden zum Abenteuer ${adventure.adventureName} eingeladen`,
                        userId: Number(uta.User.userId)
                    },
                    refetchQueries: [
                        {
                            query: GetMessages,
                            variables: {
                                userId: Number(user.userId)
                            }
                        } ]
                })
            }
        }

        const updateResponse = await updateAdventureHook({
            variables: {
                adventureId: Number(adventure.adventureId),
                adventureDescription: adventure.adventureDesc,
                adventureName: adventure.adventureName,
                user_to_adventure: userList
            },
            refetchQueries: [
                {
                    query: GetAdventureById,
                    variables: {
                        adventureId: Number(adventure.adventureId)
                    }
                } ]
        })

        if (!updateResponse.errors) {
            toast('Abenteuer erfolgreich gespeichert!')
        } else {
            toast('Fehler beim Speichern des Abenteuers')
        }
    }

    return (
        <div>
            <div className='row text-start mt-3 adventure-header-bar'>
                <div className='col-2'>
                    <h3>{adventure.adventureName}</h3>
                </div>
                <div className='col-8 justify-content-center text-center align-content-center'>
                    <div className='row justify-content-center'>
                        <div className='col-2'>
                            <Button className={checkForSelectedTab(Tabs.Overview)}
                                    onClick={() => setSelectedTab(Tabs.Overview)}>Übersicht</Button>
                        </div>
                        <div className='col-2'>
                            <Button className={checkForSelectedTab(Tabs.Spielerverwaltung)}
                                    onClick={() => setSelectedTab(Tabs.Spielerverwaltung)}>Spielerverwaltung</Button>
                        </div>
                        <div className='col-2'>
                            <Button className={checkForSelectedTab(Tabs.Spieleroverview)}
                                    onClick={() => setSelectedTab(Tabs.Spieleroverview)}>Spielerübersicht</Button>
                        </div>
                        <div className='col-2'>
                            <Button className={checkForSelectedTab(Tabs.NPCTab)}
                                    onClick={() => setSelectedTab(Tabs.NPCTab)}>NPC's</Button>
                        </div>
                    </div>
                </div>
                <div className='col-2'>
                    <Button onClick={async () => await handleUpdateAdventure()}><SaveAltSharp/> Speichern</Button>
                </div>
            </div>
            <div className='row mt-3 adventure-content justify-content-center text-center'>
                {renderContent()}
            </div>
        </div>
    )
}